import React from "react";
import { useSelector } from "react-redux";
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Table
} from "reactstrap";
import CurrencyFormat from 'react-currency-format';

const piutang = ({ onLihatPiutangCommand }) => {
    const { data, loading } = useSelector(state => ({
        data: state.Dashboard.data,
        loading: state.Dashboard.loading,
    }));

    return <>
        {
            data && !loading &&
            <Card>
                <CardBody>
                    <div>
                        <CardTitle>Piutang</CardTitle>
                    </div>
                    <div className="table mt-3">
                        <Table style={{ width: '100%' }}>
                            <tbody>
                                <tr>
                                    <td>Total</td>
                                    <td className="text-end pt-2">
                                        <h4>
                                            <CurrencyFormat value={data.dataPiutang?.totalPiutang ?? 0} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0}
                                                displayType={'text'} />
                                        </h4>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Nominal</td>
                                    <td className="text-end  pt-2">
                                        <h4>
                                            <CurrencyFormat value={data.dataPiutang.totalNominalPiutang ?? 0} thousandSeparator={'.'} decimalSeparator={','} decimalScale={2}
                                                displayType={'text'} />
                                        </h4>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Total Belum Lunas</td>
                                    <td className="text-end pt-2">
                                        <h4>
                                            <CurrencyFormat value={data.dataPiutang.totalPiutangBelumLunas ?? 0} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0}
                                                displayType={'text'} />
                                        </h4>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Nominal Belum Dibayarkan</td>
                                    <td className="text-end pt-2">
                                        <h4>
                                            <CurrencyFormat value={data.dataPiutang.totalNominalPiutangBelumLunas ?? 0} thousandSeparator={'.'} decimalSeparator={','} decimalScale={2}
                                                displayType={'text'} />
                                        </h4>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Overdue</td>
                                    <td className="text-end pt-2">
                                        <h4>
                                            <CurrencyFormat value={data.dataPiutang.dataPiutangOverdue?.length ?? 0} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0}
                                                displayType={'text'} />
                                        </h4>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                    {
                        data.dataPiutang.dataPiutangOverdue && data.dataPiutang.dataPiutangOverdue.length > 0 &&
                        <>
                            <CardTitle className="mb-2 mt-5">Piutang Overdue</CardTitle>
                            <div className="table mt-3">
                                <table style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Reminder Date</th>
                                            <th>Remarks</th>
                                            <th>Nominal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            data.dataPiutang.dataPiutangOverdue.map(piutang => {
                                                return <tr key={'dataPiutang' + piutang.id}>
                                                    <td>{piutang.dateLong}</td>
                                                    <td>{piutang.remarks}</td>
                                                    <td>
                                                        <CurrencyFormat value={piutang.nominal ?? 0} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0}
                                                            displayType={'text'} />
                                                    </td>
                                                </tr>
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="d-flex justify-content-center">
                                <Button color="primary" className="btn btn-primary" onClick={onLihatPiutangCommand}>
                                    Lihat Selengkapnya
                                </Button>
                            </div>
                        </>
                    }
                </CardBody>
            </Card>
        }
    </>
}

export default piutang;